import {
  Box,
  type BoxProps,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  OutlinedInput,
  Typography,
  styled,
} from "@mui/material";
import { rem } from "polished";
import React, { useRef } from "react";
import { Controller, useForm } from "react-hook-form";

import { Loader } from "src/components";
import { useDeviceWidth } from "src/hooks";
import { useCleanLoginInput } from "src/hooks/useCleanLoginInput";
import { emailPattern } from "src/utils";

const Container = styled(Box)`
  ${(props) => props.theme.breakpoints.down("sm")} {
    padding: ${(props) => props.theme.spacing(1)};
  }
`;

const StyledParagraph = styled(Typography)`
  font-size: ${rem(16)};
`;
interface Props extends BoxProps {
  email?: string | null;
  handleClose(): void;
  onSubmitEmail: (emailValue: string) => void;
  subscriptionLoading: boolean;
  updateCustomerLoading: boolean;
}

export const ERecoSubscriptionForm = ({
  handleClose,
  email,
  onSubmitEmail,
  subscriptionLoading,
  updateCustomerLoading,
  ...boxProps
}: Props) => {
  const { isMobile } = useDeviceWidth();

  const {
    control,
    formState: { errors },
    watch,
    handleSubmit,
  } = useForm<{ email: string }>({
    defaultValues: { email: email || "" },
  });

  const emailValue = watch("email");

  const emailInputContainerRef = useRef<HTMLElement>();
  useCleanLoginInput({ attribute: "name", value: "email" }, emailInputContainerRef);

  return (
    <Container {...boxProps}>
      <StyledParagraph align="center">
        Votre adresse mail de contact est nécessaire pour l’envoi des eReco,
      </StyledParagraph>
      <StyledParagraph align="center">
        merci de valider celle-ci afin de valider votre souscription au service dématéralisé E-reco.
      </StyledParagraph>
      <Box component="form" sx={{ pt: 2, pb: 6, width: isMobile ? 275 : 400 }}>
        {subscriptionLoading ? (
          <Loader />
        ) : (
          <Box sx={{ mt: 2 }}>
            <FormControl fullWidth variant="outlined" error={Boolean(errors.email)}>
              <InputLabel htmlFor="email">Email</InputLabel>
              <Controller
                name="email"
                control={control}
                rules={{
                  required: "Un email est requis",
                  pattern: { value: emailPattern, message: "Email invalide" },
                }}
                render={({ field }) => (
                  <OutlinedInput
                    disabled={email ? emailPattern.test(email) : false}
                    label="Email"
                    placeholder="Votre adresse email"
                    {...field}
                    inputRef={emailInputContainerRef}
                  />
                )}
              />
              <FormHelperText>{errors.email?.message}</FormHelperText>
            </FormControl>
          </Box>
        )}

        {!subscriptionLoading && (
          <Box sx={{ mt: 2 }}>
            <Button
              loading={updateCustomerLoading}
              type="submit"
              onClick={handleSubmit(() => onSubmitEmail(emailValue))}
              fullWidth
              variant="contained"
            >
              Valider
            </Button>
          </Box>
        )}
      </Box>
      <Button variant="outlined" onClick={handleClose} sx={{ display: "flex", mx: "auto", mb: 4 }}>
        Annuler
      </Button>
    </Container>
  );
};
